import { memo } from 'react'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: theme.zIndex.modal - 1
  },
  title: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
}))

function DialogComponent(props) {
  const {
    title,
    message,
    children,
    open,
    onSubmit,
    onClose,
    onFinish,
    cancelButtonText,
    finishButtonText,
    buttons,
    disableDefaultButtons,
    ...rest
  } = props
  const { t } = useTranslation('common')
  const classes = useStyles()

  return (
    <Dialog className={classes.root} open={open} onClose={onClose} {...rest}>
      <DialogTitle className={classes.title} disableTypography>
        <Typography>{title}</Typography>
        {props.onClose ? (
          <IconButton
            size='small'
            className={classes.closeButton}
            onClick={props.onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent>
        {message && message.length > 0 ? (
          <DialogContentText>{message}</DialogContentText>
        ) : null}
        {children}
      </DialogContent>
      {!disableDefaultButtons || buttons.length > 0 ? (
        <DialogActions>
          {buttons && buttons.length > 0 ? (
            buttons.map((button, index) => (
              <Button
                key={index}
                color={button.color}
                type='submit'
                onClick={button.action}>
                {button.text}
              </Button>
            ))
          ) : (
            <>
              <Button type='submit' onClick={onClose}>
                {cancelButtonText || t('cancel')}
              </Button>
              <Button color='primary' onClick={handleSubmit}>
                {finishButtonText || t('submit')}
              </Button>
            </>
          )}
        </DialogActions>
      ) : null}
    </Dialog>
  )

  function handleSubmit() {
    onFinish()
    onClose()
  }
}

DialogComponent.defaultProps = {
  buttons: [],
  disableDefaultButtons: false
}

export default memo(DialogComponent)
